module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_kyoto-cdc821cad6f583926b70bdc6281b50b5.jpg";